/**
 * @file 書類の削除
 */
'use strict';

/**
 * @classname BtnDeleteDocument
 * @classdesc 書類の削除
 */
export default class BtnDeleteDocument {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e, controller) {
		console.log('BtnDeleteDocument.constructor');
		this._$e = $e;
		this._controller = controller;
		this._id = this._$e.attr('data-document-id');
		this._$deleteBtn = $('.btn--modal-delete-document');
		this._$modal = $('.modal-delete-document');
		this._$overlay = $('#overlay')
		this._$e.on('click', () => this.onClick());
		this._$deleteBtn.on('click', () => this.onClickDeleteBtn());
		this._controller.on('deleteDocumentComplete', () => this.onDeleteDocumentComplete());

	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnDeleteDocument
	 * @return {undefined}
	 */
	onClick() {
		console.log('BtnDeleteDocument.onClick');
		$('#document_id').val(this._id);
	};


	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnDeleteDocument
	 * @return {undefined}
	 */
	onClickDeleteBtn() {
		console.log('BtnDeleteDocument.onClickDeleteBtn');
		this._controller.deleteDocument($('#document_id').val(), $('#document_id').attr('name'));
	};


	/**
	 * 削除完了後
	 *
	 * @memberof BtnDeleteDocument
	 * @return {undefined}
	 */
	onDeleteDocumentComplete() {
		if (this._id !== this._controller._processingDocumentId) return;
		console.log('BtnDeleteDocument.onDeleteDocumentComplete');
		this._$e.closest('.list-item').remove();
		$('#document_id').val('')
	};
}
